import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65e5059c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full bg-slate-50" }
const _hoisted_2 = { class: "h-full flex p-3 bg-slate-50 items-center justify-center" }
const _hoisted_3 = { class: "max-w-5xl h-[97%] sm:flexxx rounded-lg" }
const _hoisted_4 = { class: "p-3" }
const _hoisted_5 = {
  style: {"display":"flex"},
  class: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://assets.brian.com.co/web/flags/usa.png",
  alt: "",
  width: "24"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://assets.brian.com.co/web/flags/spain.png",
  alt: "",
  width: "24"
}, null, -1))

import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

import TwDivider from "@/components/TwDivider.vue";
import HadFacial from "@/components/FormComponents/1.HadFacial.vue";
import HaveReceivedBotoxAndOthers from "@/components/FormComponents/2.HaveReceivedBotoxAndOthers.vue";
import CurrentlyUseAccutaneAndOthers from "@/components/FormComponents/3.CurrentlyUseAccutaneAndOthers.vue";
import TakingMedicationsAndOthers from "@/components/FormComponents/4.TakingMedicationsAndOthers.vue";
import HaveTanningLast48Hours from "@/components/FormComponents/5.HaveTanningLast48Hours.vue";
import SkinType from "@/components/FormComponents/6.SkinType.vue";
import SkinTypeDescription from "@/components/FormComponents/7.SkinTypeDescription.vue";
import AreasOfConcernInSkin from "@/components/FormComponents/8.AreasOfConcernInSkin.vue";
import ExperienceBurningItchingSensation from "@/components/FormComponents/9.ExperienceBurningItchingSensation.vue";
import ExperienceSkinBreakouts from "@/components/FormComponents/10.ExperienceSkinBreakouts.vue";
import ExperienceOilyShine from "@/components/FormComponents/11.ExperienceOilyShine.vue";

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormView',
  setup(__props) {

const store = useStore();

const form = computed(() => store.state.form);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: '/',
              class: "mr-2"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: '/es' }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).dispatch('resetFormState'))),
              class: "ml-3 mr-3"
            }, " Limpiar ")
          ])
        ]),
        _createVNode(HadFacial),
        _createVNode(TwDivider),
        _createVNode(HaveReceivedBotoxAndOthers),
        _createVNode(TwDivider),
        _createVNode(CurrentlyUseAccutaneAndOthers),
        _createVNode(TwDivider),
        _createVNode(TakingMedicationsAndOthers),
        _createVNode(TwDivider),
        _createVNode(HaveTanningLast48Hours),
        _createVNode(TwDivider),
        _createVNode(SkinType),
        _createVNode(TwDivider),
        _createVNode(SkinTypeDescription),
        _createVNode(TwDivider),
        _createVNode(AreasOfConcernInSkin),
        _createVNode(TwDivider),
        _createVNode(ExperienceBurningItchingSensation),
        _createVNode(TwDivider),
        _createVNode(ExperienceSkinBreakouts),
        _createVNode(TwDivider),
        _createVNode(ExperienceOilyShine),
        _createVNode(TwDivider)
      ])
    ])
  ]))
}
}

})